import axios from 'axios'

const LMS_USER_API_URL = '/api'
axios.defaults.withCredentials = true

export default {
  createOrder (data) {
    return axios.post(LMS_USER_API_URL + '/gp-webpay/order', data)
  },
  loadOrder (ordernumber) {
    return axios.get(LMS_USER_API_URL + '/gp-webpay/order/' + ordernumber)
  }
}



// WEBPACK FOOTER //
// ./src/backend-resources/gp-webpay-resource.js